export const geoapifyApiKey = document.body.dataset.geoapifyApiKey as string
export const billwerkApiKey = document.body.dataset.billwerkApiKey ?? ""
export const billwerkSelfServiceToken =
  document.body.dataset.billwerkSelfServiceToken ?? ""
